import keyMirror from "keymirror";

export default keyMirror({
  INIT_SEARCHRESULTS: null,
  SAVE_FORM_INPUT_SEARCH: null,
  LOADING:null
});
